import React, { useState, useEffect } from "react";
import { crearSector, modificarSector, eliminarSector } from "../../services/SectorService";
import { obtenerEstructuraCompleta } from "../../services/api";

export default function MantenedorSector() {
  const [sectores, setSectores] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [mostrarModal, setMostrarModal] = useState(false);
  const [editando, setEditando] = useState(false);
  const [sectorForm, setSectorForm] = useState({ sectorId: 0, moduloId: 0, sectorNombre: "", estadoId: 1 });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    try {
      const estructura = await obtenerEstructuraCompleta();
      const campos = estructura.datos[0].campos || [];
      const modulosApi = campos.flatMap(campo =>
        campo.modulos.map(mod => ({ ...mod, campoNombre: campo.campoNombre }))
      );
      setModulos(modulosApi);
      const sectoresApi = modulosApi.flatMap(mod =>
        mod.sectores.map(sec => ({
          ...sec,
          moduloNombre: mod.moduloNombre,
          campoNombre: mod.campoNombre
        }))
      );
      setSectores(sectoresApi);
    } catch (error) {
      console.error("Error al cargar sectores:", error);
    }
  };

  const abrirNuevo = () => {
    setSectorForm({ sectorId: 0, moduloId: modulos[0]?.moduloId || 0, sectorNombre: "", estadoId: 1 });
    setEditando(false);
    setMostrarModal(true);
  };

  const abrirEditar = sec => {
    setSectorForm({ sectorId: sec.sectorId, moduloId: sec.moduloId, sectorNombre: sec.sectorNombre, estadoId: sec.estadoId });
    setEditando(true);
    setMostrarModal(true);
  };

  const guardar = async () => {
    try {
      const payload = { ...sectorForm };
      if (editando) await modificarSector(payload);
      else await crearSector(payload);
      setMostrarModal(false);
      cargarDatos();
    } catch (error) {
      console.error("Error al guardar sector:", error);
    }
  };

  const eliminarRegistro = async sec => {
    if (!window.confirm(`¿Eliminar sector "${sec.sectorNombre}"?`)) return;
    try {
      await eliminarSector(sec);
      cargarDatos();
    } catch (error) {
      console.error("Error al eliminar sector:", error);
    }
  };

  return (
    <div className="p-6 bg-white rounded-md shadow-md font-sans">
      <header className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">🌾 Mantenedor de Sectores</h1>
        <button
          onClick={abrirNuevo}
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
        >
          + Nuevo Sector
        </button>
      </header>

      <div className="overflow-x-auto border border-gray-200 rounded-md shadow-md">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {['ID','Nombre','Módulo','Campo','Estado','Acciones'].map(col => (
                <th key={col} className="px-6 py-3 text-left text-xs font-medium text-gray-600 uppercase tracking-wider">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {sectores.map(s => (
              <tr key={s.sectorId} className="odd:bg-white even:bg-gray-50 hover:bg-gray-100 transition">
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{s.sectorId}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{s.sectorNombre}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{s.moduloNombre}</td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700">{s.campoNombre}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={
                    s.estadoId===1
                      ? 'inline-block px-3 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800'
                      : 'inline-block px-3 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800'
                  }>
                    {s.estadoId===1?'Activo':'Inactivo'}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap flex space-x-2">
                  <button
                    onClick={() => abrirEditar(s)}
                    className="px-3 py-1 border border-blue-600 text-blue-600 rounded-md hover:bg-blue-50 transition"
                  >Editar</button>
                  <button
                    onClick={() => eliminarRegistro(s)}
                    className="px-3 py-1 border border-red-600 text-red-600 rounded-md hover:bg-red-50 transition"
                  >Eliminar</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {mostrarModal && (
        <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
          <div className="bg-white w-full max-w-md rounded-md shadow-lg p-6 font-sans">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {editando ? '✏️ Editar Sector' : '➕ Nuevo Sector'}
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Módulo</label>
                <select
                  value={sectorForm.moduloId}
                  onChange={e => setSectorForm({ ...sectorForm, moduloId: parseInt(e.target.value,10) })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                >
                  {modulos.map(m => (
                    <option key={m.moduloId} value={m.moduloId}>
                      {m.campoNombre} - {m.moduloNombre}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nombre sector</label>
                <input
                  type="text"
                  value={sectorForm.sectorNombre}
                  onChange={e => setSectorForm({ ...sectorForm, sectorNombre: e.target.value })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Estado</label>
                <select
                  value={sectorForm.estadoId}
                  onChange={e => setSectorForm({ ...sectorForm, estadoId: parseInt(e.target.value,10) })}
                  className="mt-1 block w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:border-blue-500"
                >
                  <option value={1}>Activo</option>
                  <option value={2}>Inactivo</option>
                </select>
              </div>
            </div>
            <div className="mt-6 flex justify-end space-x-3">
              <button onClick={() => setMostrarModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-100 transition">Cancelar</button>
              <button onClick={guardar} className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">Guardar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
